import React from "react";
import "./Group80.css";

function Group80() {
  return (
    <div className="group-80">
      <div className="group-64">
        <div className="path-container-3">
          <img className="path-51" src="/img/path-51@1x.png" />
          <img className="path-52" src="/img/path-52@1x.png" />
          <img className="path-53" src="/img/path-53@1x.png" />
          <img className="path-54" src="/img/path-54@1x.png" />
        </div>
      </div>
      <div className="bonus-rewards avenir-heavy-normal-eerie-black-18px">BONUS REWARDS</div>
      <p className="for-every-200-in-purchases avenir-book-normal-eerie-black-12px">FOR EVERY $200 IN PURCHASES</p>
    </div>
  );
}

export default Group80;
